<template>
    <v-form
            ref="modifyFarmForm"
            @submit.prevent=""
            class="fill-height of-y"
            :disabled="loading"
    >
        <div class="of-y">
            <div class="d-flex align-center primary pl-3 pr-2">
                <div class="flex-grow-1 sub--text">
                    {{farm.id ? 'Edit Farm' : 'Create Farm'}}
                </div>
                <div v-if="!farm.id">
                    <v-btn
                            icon
                            color="white"
                            small
                            @click="$emit('dismiss')"
                    >
                        <v-icon small>mdi-close</v-icon>
                    </v-btn>
                </div>
            </div>
            <v-divider></v-divider>
            <div class="pb-1">
                <div class="flex-grow-1 of-y px-2 pb-1">
                    <v-text-field
                            label="Farm Name"
                            hide-details="auto"
                            v-model="farm.description"
                            @input="changesMade = true"
                            :rules="[validationRules.required, validationRules.notNull]"
                            :error-messages="farmNameErrorMessages"
                    />
                </div>

                <div class="flex-grow-1 of-y px-2 pb-1">
                    <v-text-field
                            label="Bin Turnaround Time"
                            suffix="Minutes"
                            hide-details="auto"
                            v-model="farm.binTurnaround"
                            type="Number"
                            @input="changesMade = true"
                            :rules="[validationRules.required, validationRules.notNull]"
                    />
                </div>
              
              <div class="flex-grow-1 of-y px-2 pb-1">
                <v-text-field
                    label="Max Employees per bin"
                    suffix="Employees"
                    hide-details="auto"
                    v-model.number="farm.maxEmpPerBin"
                    type="Number"
                    @input="changesMade = true"
                    :rules="[validationRules.required, validationRules.notNull]"
                />
              </div>

                <div class="flex-grow-1 of-y px-2 pb-1">
                    <v-text-field
                            label="Export ID"
                            hide-details="auto"
                            v-model="farm.exportID"
                            @input="changesMade = true"
                            :rules="[validationRules.required, validationRules.notNull]"
                    />
                </div>


                <div class="text-right pr-2 pb-1 pt-2">
                    <v-btn
                            @click="validateSave()"
                            fab
                            small
                            color="secondary"
                            :loading="loading"
                            :disabled="!changesMade || loading"
                    >
                        <v-icon v-if="!loading">mdi-content-save</v-icon>
                    </v-btn>
                </div>
            </div>
        </div>
    </v-form>
</template>

<script>
import {mapGetters} from 'vuex'
import {validationRules} from "../../../core/codeFunctions";

export default {
    components: {},
    props: {
        editFarm: Object
    },
    data() {
        return {
            farm: null,
            farmNameErrorMessages: null,
            loading: false,
            validationRules: validationRules,
            changesMade: false
        }
    },
    watch: {
        editFarm: {
            deep: true,
            immediate: true,
            handler(val) {
                this.changesMade = false
                console.log(val)
                this.farm = JSON.parse(JSON.stringify(val))
            }
        },
        "farm.description"() {
            this.farmNameErrorMessages = null
        }
    },
    methods: {
        validateSave() {
            if (this.farms.filter(obj => obj.id !== this.farm.id && obj.description.toLowerCase() === this.farm.description.toLowerCase()).length) {
                this.farmNameErrorMessages = 'Farm name already exists'
                return false
            }

            if (!this.$refs.modifyFarmForm.validate())
                return false

            this.$emit('save', {farm: this.farm, ref: this})
        }
    },
    computed: {
        ...mapGetters(['farms'])
    },
}
</script>

<style scoped>

</style>